<template>
<v-expansion-panel-content>
    <v-row>
        <v-col
            cols="12"
            v-for="seller in shop.sellers"
            :key="shopid + '/' + seller.name"
            >

            <v-card
                dark
                shaped
                class="blueMain"
                >
<!-- Первая строка Продавец, Индекс пользы -->
                <v-row>
                    <v-avatar>
                        <v-img :src="'https://eu.ui-avatars.com/api/?size=128&background=F39314&color=FFF&bold=true&name=' + seller.name" ></v-img>
                    </v-avatar>
                    <v-col cols=7>
                        <span class="ml-3">
                                {{seller.name}}
                        </span>
                        <span
                            v-if="seller.work != 'no'"
                            class="orange--text
                            font-weight-bold">
                            &deg;
                        </span>
                        <br>
                        <a
                            :href="'tel:' + seller.phone"
                            style="text-decoration: none"
                            class="blueLigth--text ml-3"
                            >
                            {{seller.phone}}
                        </a>
                    </v-col>
                    <v-col cols=3>
                        <div class="text-right blueLigth--text">
                            {{seller.status}}
                        </div>
                        <div
                            :class="seller.efficiency >= 90 ?
                                    'orangeMain--text' : 'red--text text--lighten-1'"
                            class="text-right title-1"
                            >
                            {{seller.efficiency.toFixed() + '%'}}
                        </div>
                    </v-col>
                </v-row>

<!-- Вторая строка Косяки и статистика -->
                <v-row dense class="mx-3">
                    <v-col cols="2">
                        <v-btn
                            class="blueMain"
                            elevation=6
                            x-small
                            fab
                            @click="dialog=true; active_seller=seller"
                            >
                            <v-icon>smoking_rooms</v-icon>
                        </v-btn>
                        <v-btn v-if="seller.leader"
                            class="blueMain ml-2"
                            elevation=6
                            x-small
                            fab
                            :disabled="~seller.addon.indexOf('noleader') || !check_date() ? true : false"
                            @click="dialog2=true;
                                    active_seller=seller;
                                    type='noleader'"
                            >
                            <v-icon>accessible</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <div
                            v-for="(bug, i) in seller.points"
                            :key="i"
                            >
                            <v-icon
                                v-for="count in bug.count"
                                :key="i + count"
                                class="orangeDark--text"
                                >
                                clear
                            </v-icon>
                            <span class="ml-2 font-weight-thin">
                                {{ bug.comment }}
                            </span>
                        </div>
                    </v-col>

                    <v-col cols="2">
                        <div class="text-right">{{seller.factP + "%"}}</div>
                        <div class="text-right"
                            :class="seller.prognosisP >= 90 ?
                                    'orangeMain--text' : 'red--text text--lighten-1'">
                            {{seller.prognosisP + "%"}}</div>
                    </v-col>

                    <v-col cols="2">
                        <div class="font-weight-thin text-right">
                            {{seller.factM | moneyM}}
                        </div>
                        <div class="orangeMain--text font-weight-thin text-right">
                            {{seller.planM | moneyM}}
                        </div>
                    </v-col>
                </v-row>

<!-- Третья строка  Кнопки дебафов -->
                <v-row dense class="mx-2 mt-2"
                    v-if="Object.keys(aver).length > 0 &&
                          !~['стажер', 'юниор'].indexOf(seller.status)">
                    <!-- <v-col cols=6>
                        <template v-if="check_addon(seller, 'offence')">
                        <v-btn
                            color="orangeDark"
                            elevation=24
                            fab
                            :disabled="check_addon(seller, 'offence')"
                            @click="dialog2=true;
                                    active_seller=seller;
                                    type='offence'"
                            >
                            <v-icon>thumb_down</v-icon>
                        </v-btn>
                        <br>
                        <span class="font-weight-thin blueLigth--text">
                            {{`штрафы (${aver[String(seller.id)].points})`}}
                        </span>
                        </template>
                    </v-col>
                    <v-col cols=6 class="text-right">
                        <template
                            v-if="check_addon(seller, 'efficiency')">
                        <v-btn
                            color="orangeDark"
                            elevation=0
                            fab
                            :disabled="check_addon(seller, 'efficiency')"
                            @click="dialog2=true;
                                    active_seller=seller;
                                    type='efficiency'"
                            dark>
                            <v-icon>thumb_down</v-icon>
                        </v-btn>
                        <br>
                        <span v-if="aver[String(seller.id)]"
                            class="font-weight-thin blueLigth--text">
                            {{`эффективность (${aver[String(seller.id)].effectiv}%)`}}
                        </span>
                        </template>
                    </v-col> -->
                    <v-col cols=12 md=6>
                        <v-alert text outlined 
                        v-if="~seller.addon.indexOf('offence')"
                                  color="deep-orange"
                                  icon="mdi-fire">
                                  штрафные баллы
                            <v-btn icon @click="del_addon(seller, 'offence')"
                            class="mt-n1" v-if="check_date()">
                              <v-icon>
                                cancel
                              </v-icon>
                            </v-btn>
                        </v-alert>
                    </v-col>
                    <v-col cols=12 md=6>
                        <v-alert text outlined 
                        v-if="~seller.addon.indexOf('efficiency')"
                                  color="deep-orange"
                                  icon="mdi-fire">
                                  эффективность
                            <v-btn icon @click="del_addon(seller, 'efficiency')"
                            class="mt-n1" v-if="check_date()">
                              <v-icon>
                                cancel
                              </v-icon>
                            </v-btn>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>

<!-- Диалоги -->
    <v-dialog
        v-model="dialog"
        persistent
        >
        <v-card
            class="mx-auto orangeDark"
            width=600
            >
            <v-card-title>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <form>
                        <v-text-field
                            class="blueDark--text"
                            v-model="points"
                            :error-messages="pointError"
                            label="Количество баллов"
                            required
                            ></v-text-field>
                        <v-text-field
                            class="blueDark--text"
                            v-model="comment"
                            :error-messages="commentError"
                            label="Комментарий"
                            required
                            ></v-text-field>
                    </form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn
                    text
                    @click="dialog=false"
                    >
                    Закрыть
                </v-btn>
                <v-btn
                    :disabled="commentError || pointError || !this.points ?
                               true : false"
                    text
                    @click="add_points(active_seller); dialog=false"
                    >
                    Сохранить
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialog2"
        >
        <v-card
            class="mx-auto orangeDark"
            width=600
            >
            <v-card-title>
            </v-card-title>

            <v-card-text>
                Уверены, что хотите депремироварвать сотрудника?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="dialog2 = false"
                    >
                    Нет
                </v-btn>

                <v-btn
                    text
                    @click="add_addon(active_seller, type); dialog2 = false"
                    >
                    Да
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</v-expansion-panel-content>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'

export default {
name: 'Sellers',
props: {
    shopid: {
        type: String,
    },
},
data: () => ({
    dialog: false,
    dialog2: false,
    points: '',
    comment: '',
    active_seller: {},
    badeffect: 90,
    badpoint: 3,
    type: ''
}),

computed: {

  ...mapState(['totalInfo', 'domen', 'aver', 'date']),

  today: function() {
    if (Object.keys(this.shop).length > 0 &&
        this.shop.workingDays.length > 0) {
        return this.shop.workingDays[this.shop.workingDays.length - 1];
    }
    return {};
  },

  commentError: function() {
      if (this.comment.length > 100) return "Слишком длинный комментарий"
      return undefined
  },
  pointError: function() {
      if (this.points && (isNaN(this.points) || this.points.length > 1))
          return "Некорректное значение"
      return undefined
  },

  shop: function() {
    for (let el of this.totalInfo.shops){
        if (el.ID == this.shopid) {
          return el;
        }
    }
    return {};
  }

},

methods: {

  add_points(seller){
    let comment = this.comment;
    let points = this.points;
    return axios.post(this.domen + '/service/addpoint', {
        'id': seller.id,
        'comment': comment.toLowerCase(),
        'count': points
    }).then(res => res.data)
      .then(json => {
        if (json['response'] == 'ok'){
            // window.console.log(json['response'], comment, points);
            if (!seller.points) seller.points = [];
            seller.points.push({'comment': comment,
                                'count': +points});
        }
    });
  },

  del_addon(seller, type){
    return axios.post(this.domen + '/service/deladdon', {
        'id': seller.id,
        'type': type
    }).then(res => res.data)
      .then(json => {
        if (json['response'] == 'ok'){
            seller.addon = seller.addon.filter(el => el != type);
        }
    });
  },

  add_addon(seller, type){
    return axios.post(this.domen + '/service/addaddon', {
        'id': seller.id,
        'type': type
    }).then(res => res.data)
      .then(json => {
        if (json['response'] == 'ok'){
            if (!seller.addon) seller.addon = [];
            seller.addon.push(type);
        }
    });
  },

  check_addon(seller, type){
    return seller.addon && ~seller.addon.indexOf(type) ? true : false;
  },

  check_date(){
    return (new Date(this.date).getFullYear() == new Date().getFullYear() &&
            new Date(this.date).getMonth() == new Date().getMonth()) ?
              true : false;
  }
},

watch: {

  dialog () {
      if (!this.dialog) {
          this.points = this.comment = '';
          this.active_seller = {};
      }
  },

  dialog2 () {
      if (!this.dialog2) {
          this.type = '';
          this.active_seller = {};
      }
  }

},

created: function() {
}


}


</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
